import { render } from "./Dashboard.vue?vue&type=template&id=731c58e8&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-731c58e8"

export default script